<template>
    <div>
        <div class="host-info">
            <div class="img">
                <img :src="user.photo_url" class="img-circle img-thumbnail" alt="profile-image">
            </div>
            <div class="content text-left">
                <h3 class="m-b-0">{{ user.full_name }}</h3>
                <div class="m-b-10 m-t-5">
                    <span class="badge badge-gray m-r-10">Taxa de Resposta: {{ user.response_rate }}
                        <i data-toggle="tooltip" data-placement="top" title="Porcentagem de contatos que esta pessoa respondeu." class="far fa-question-circle"></i>
                    </span>

                    <span class="font-13 m-t-5 m-b-5">Online {{ user.last_activity }}</span>
                </div>
                <span v-if="user.verified_account" class="verified m-b-5"><img src="/images/verified.png" alt=""> Conta Verificada</span>
                <a id="lnk_about_owner" class="btn-link" href="#">Mais sobre {{ user.full_name }}</a>
            </div>
        </div>
        <div class="m-t-20">
            <div id="frm_message">
                <form class="text-left" v-if="!message_sent && !msg_success && !invitation" v-on:submit.prevent="sendMessage($event)">
                    <h5 class="text-custom m-b-15"><i class="far fa-envelope m-r-10"></i> Tem interesse? Envie uma mensagem para {{ user.full_name }}.</h5>
                    <div class="row m-b-10">
                        <div class="col-xs-12 col-sm-6">
                            <div class="form-group" v-bind:class="{'has-error': errors.has('moving_date')}">
                                <label for="moving_date" class="control-label">Data de Mudança</label>
                                <date-picker
                                    v-model="form.moving_date"
                                    :disabled-date="disabledDate"
                                    :open.sync="open_picker"
                                    value-type="format"
                                    format="DD/MM/YYYY">
                                        <template v-slot:input>
                                            <input type="tel"
                                                class="form-control"
                                                data-vv-as="Data de Mudança"
                                                autocomplete="off"
                                                v-validate="'date_format:dd/MM/yyyy'"
                                                v-mask="'##/##/####'"
                                                placeholder="dd/mm/aaaa"
                                                @input="dateChange"
                                                v-model="form.moving_date" name="moving_date"/>
                                        </template>
                                </date-picker>
                                <span class="help-block text-left" v-show="errors.has('moving_date')">
                                    <strong>{{ errors.first('moving_date') }}</strong>
                                </span>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <div class="form-group" v-bind:class="{'has-error': errors.has('staying_time')}">
                                <label for="staying_time" class="control-label">Tempo de Permanência</label>
                                <select class="form-control" v-model="form.staying_time" data-vv-as="Tempo de Permanência" v-validate="'required'" name="staying_time">
                                    <option value="">Selecione</option>
                                    <option>Menos de 1 mês</option>
                                    <option>Até 3 meses</option>
                                    <option>Até 6 meses</option>
                                    <option>Mais de 6 meses</option>
                                    <option>Indeterminado</option>
                                </select>
                                <span class="help-block text-left" v-show="errors.has('staying_time')">
                                    <strong>{{ errors.first('staying_time') }}</strong>
                                </span>
                            </div>
                        </div>

                    </div>
                    <div @click="canUserMessage($event)" class="dv_msg_success text-left">
                        <div class="form-group" v-bind:class="{'has-error': errors.has('message')}">
                            <label for="message" class="control-label">Mensagem</label>
                            <textarea name="message" v-validate="'required'" class="form-control" v-model="form.message" :placeholder="'Digite aqui sua mensagem para ' + user.first_name + '.'" rows="4"></textarea>
                            <div class="scroll-wrap" data-simplebar>
                                <div class="text-helpers">
                                    <p v-for="(text, index) in text_suggestions" :key="index" @click="copyText(index)">{{ text }}</p>
                                </div>
                            </div>
                            <span class="help-block text-left" v-show="errors.has('message')">
                                <strong>{{ errors.first('message') }}</strong>
                            </span>
                        </div>
                    </div>

                    <button @click="canUserMessage($event)" type="submit" class="btn btn-success btn-invitation btn-lg btn-block waves-effect waves-light ladda-button">
                        <span class="ladda-label">Enviar Mensagem</span>
                    </button>
                </form>
                <div v-if="invitation">
                    <div v-if="invitation.fk_status == 2">
                        <div class="dv_msg msg_success">
                            <img class="icon" src="/images/sent.svg" alt="">
                            <h4 class="text-custom">Mensagem enviada com sucesso. E agora?</h4>
                            <p>Enviamos sua mensagem para {{ user.first_name }}. Fique atento(a) a sua caixa de mensagens e notificações para saber quando {{ user.first_name }} te responder.</p>
                            <div>
                                <hr>
                                <p>Aproveite e baixe nosso app, assim você é notificado quando {{ user.first_name }} atualizar este convite 😉!</p>
                                <div class="row link_app m-b-15">
                                    <a class="m-r-10" href="https://play.google.com/store/apps/details?id=com.webquarto.b2c.app&referrer=utm_source%3Dwebquarto_website%26utm_medium%3Dwebsite_footer" target="_blank">
                                        <img src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png" alt="" width="130" srcset="">
                                    </a>
                                    <a href="https://apps.apple.com/br/app/webquarto/id1490298196" target="_blank">
                                        <img src="https://www.webquarto.com.br/images/appstore.png" alt="" width="120">
                                    </a>
                                </div>
                            </div>
                            <a :href="'/mensagens/' + user.id" class="btn btn-success btn-block btn-message-sent">Ver Caixa de Mensagens</a>
                        </div>
                    </div>
                    <div v-else-if="invitation.fk_status === 4 || invitation.fk_status === 5 || invitation.fk_status === 3 || invitation.fk_status === 8 || invitation.fk_status === null">
                        <div class="dv_msg msg_success">
                            <img class="icon" src="/images/accepted.svg" alt="" width="55">
                            <h4 class="text-custom">Você já possui uma conversa em andamento com {{ user.first_name }}.</h4>
                            <p>Clique no botão abaixo para abrir sua conversa com {{ user.first_name }}.</p>
                            <a :href="'/mensagens/' + user.id" class="btn btn-success btn-block btn-message-sent">Ver Conversa</a>
                        </div>
                    </div>
                    <div v-else-if="invitation.fk_status === 6">
                        <div class="dv_msg msg_danger">
                            <i class="far fa-2x fa-times-circle text-danger"></i>
                            <h4 class="text-danger">{{ user.first_name }} recusou o seu interesse neste anúncio.</h4>
                            <p>Dentro de {{ invitation.liberation_date }} dias, você poderá enviar um novo convite para {{ user.first_name }}.</p>
                        </div>
                    </div>
                    <div v-else>
                        <div class="dv_msg msg_danger">
                            <i class="far fa-2x fa-times-circle text-danger"></i>
                            <h4 class="text-danger">Você recusou o convite de {{ user.first_name }} para este anúncio.</h4>
                            <p>{{ user.first_name }} te enviou um convite para conhecer este imóvel, mas você acabou recusando o convite. Clique no botão
                                abaixo para ver sua conversa com {{ user.first_name }}.</p>
                            <a :href="'/mensagens/' + user.id" class="btn btn-success btn-block btn-message-sent">Ver Conversa</a>
                        </div>
                    </div>
                </div>
                <div class="text-left m-t-15" id="contact_block">
                    <a class="btn-link text-danger p-0" role="button" data-toggle="collapse" href="#collapseSecurity" aria-expanded="false" aria-controls="collapseSecurity">Veja nossas dicas de segurança, antes de iniciar o contato com essa pessoa.</a>
                    <div class="collapse" id="collapseSecurity">
                        <ul class="m-t-20">
                            <li>Não faça nenhum depósito antecipado, sem antes visitar o local e conhecer o anunciante.</li>
                            <li class="m-t-10">Caso esse anunciante te peça para transferir qualquer valor antecipado, denuncie o mesmo.</li>
                            <li class="m-t-10"><a class="btn-link" target="_blank" href="https://ajuda.webquarto.com.br/article/60-como-saber-se-alguem-esta-tentando-me-aplicar-um-golpe">Siga nossas dicas</a>, para saber reconhecer quando alguém está tentando te aplicar um golpe.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from '../../../../../../legacy/node_modules/vue2-datepicker';
import '../../../../../../legacy/node_modules/vue2-datepicker/index.css';
	export default {
        components: {DatePicker},
        props: [
            'active_premium',
            'authenticated',
            'fk_property_ad',
            'location_object',
            'message_sent',
            'pinvitation',
            'proommate',
            'rent_price',
            'user',
            'view_phone_amount',
        ],
		data: function () {
			return {
                open_picker: false,
				msg_success: false,
                invitation: this.pinvitation,
                roommate: this.proommate,
				form: {
					message: '',
					fk_user: parseInt(this.user.id),
					initial_message: 1,
                    fk_property: parseInt(this.fk_property_ad),
                    fk_roommate: parseInt(this.fk_roommate),
					target: 'p',
                    moving_date: this.proommate ? this.proommate.moving_date : '',
                    staying_time: this.proommate ? this.proommate.staying_time : '',
                    rent_price: this.rent_price,
				},
				text_suggestions: [
					'Tenho interesse neste anúncio.',
					'Este quarto ainda está disponível?',
					'Gostaria de mais informações sobre o quarto.',
				]
			};
        },
        computed: {
            fk_roommate() {
                return this.roommate !== false ? this.roommate.id : null;
            },
            contact_capability() {
                return this.fk_roommate ? true : false;
            }
        },
		methods: {
            disabledDate(date) {
                var d = new Date().setHours(0,0,0,0);
                return date < d;
            },
            dateChange() {
                this.open_picker = false;
			},
			copyText(index) {
				this.form.message = this.text_suggestions[index];
			},
			canUserMessage($event) {
				if (!this.authenticated) {
					EventBus.$emit('open-modal', 'register-modal');
					window.dataLayer.push({
						event: 'show_login_modal',
						event_category: 'property_ad_page',
						event_label: 'send_message',
					});
                    $event.preventDefault();
					return false;
				} else {
					if (!this.contact_capability) {
						EventBus.$emit('open-modal', 'roommate-modal-form', {
                            backdrop: 'static',
                            location: this.location_object,
                            rent_price: this.rent_price
                        });

						window.dataLayer.push({
							event: 'show_roommate_form',
							event_category: 'property_ad_page',
							event_label: 'send_message',
						});
                        $event.preventDefault();
                        return false;
					}

                    if (!this.roommate.active) {
                        EventBus.$emit('open-modal', 'confirm-modal', this.roommate);
                        window.dataLayer.push({
                            event: 'show_confirm_modal',
                            event_category: 'property_ad_page',
                            event_label: 'send_message',
                        });
                    }
				}
				return true;
			},
            createRoommateAdObject() {
                this.roommate.rent_price = this.rent_price;
                this.roommate.moving_date = this.form.moving_date;
                this.roommate.staying_time = this.form.staying_time;
                this.roommate.fk_district = this.location_object.fk_district;
                this.roommate.fk_city = this.location_object.fk_city;
                this.roommate.fk_state = this.location_object.fk_state;
                this.roommate.district = this.location_object.district;
                this.roommate.lat = this.location_object.lat;
                this.roommate.lng = this.location_object.lng;
                this.roommate.has_address = true;
                delete this.roommate.wanted_amenities;

                return this.roommate;
            },
			sendMessage: function (e) {
				if (!this.canUserMessage(e))
					return;

				if (this.message_sent)
					return;

                var form = this.form;
                form.roommate_ad = this.createRoommateAdObject();

				this.$validator.validateAll().then((result) => {
					if (!result)
						return;

					let l = Ladda.create( this.$el.querySelector('.ladda-button') );
					l.start();
					axios.post('/message/send-message', form).then((response) => {
						l.stop();
						const data = response.data;
						if (data.success) {
							window.App.success('Mensagem enviada com sucesso! Fique atento a sua Caixa de Mensagens.');
							window.dataLayer.push({
								'event': 'init_contact_ad',
								'event_category': 'property_ad_page',
								'event_label': 'init_contact_ad',
							});
							this.msg_success = true;
							this.invitation = data.invitation;

                            window.dataLayer.push({
                                event: 'send_message_ab_test',
                                event_category: 'property_ad_detail_ab_test',
                                event_label: 'variant_a'
                            });
						}
					}).catch(function (error) {
						l.stop();

						if (error.response && error.response.status == 401) {
							EventBus.$emit('open-modal', 'register-modal');
							window.dataLayer.push({
								'event': 'show_login_modal',
								'event_category': 'property_ad_page',
								'event_label': 'send_message',
							});
						} else if (error.response && error.response.status === 403) {
							window.App.error('Você não pode enviar uma mensagem para esta pessoa!');
						} else
							window.App.error('Ocorreu um erro ao enviar sua mensagem. Atualize esta página e tente novamente!');
					});
				});
			}
		},
		created() {
			this.$validator.localize('pt_BR', {
				messages: {
					required: 'Preencha uma mensagem no campo acima.',
				},
			});

			EventBus.$on('roommate_ad_created', (res) => {
                this.roommate = res.roommate_ad
            });

            EventBus.$on('message_sent', (res) => {
                this.message_sent = true;
                this.invitation = res.invitation;
            });
		},
	}
</script>

<style lang="scss">
	.scroll-wrap {
		overflow-y: hidden;
		width: 100%;
        padding-bottom: 10px;
	}

    .btn-outline-orange {
        border-color: #FFC14D !important;
    }

	.text-helpers {
		display: flex;
		width: max-content;
		margin-top: 15px;
		p {
			cursor: pointer;
			margin-right: 5px;
			border: 1px solid #55748F;
			padding: 5px 10px;
			color: #55748F;
			font-size: 12px;
			border-radius: 16px;
		}
	}

	.row.link_app {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dv_msg_exist {
		background: #55748F;
		color: #FFF;
		padding: 15px;
		border-radius: 5px;
	}

	.dv_msg{
		background: #FFF;
		padding: 15px;
		border: solid 1px;
    	border-radius: 5px 5px 0 0;
		border-color: #CCC;
	}

	.dv_msg img.icon {
		width: 45px;
		margin-bottom: 15px;
	}
</style>
